import { AffectedStaff } from '../../lib/types/models/affectedStaff/affected-staff'
import { StaffMinimal } from '../../lib/types/models/staff/staff'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export type CenterFacTerrain = Pick<
  AffectedStaff,
  'id' | 'facNumber' | 'startDate' | 'endDate'
> & {
  staff: StaffMinimal
}

export function getCenterFacTerrain(id: number) {
  return restApiClient
    .url(constructApiUrl(API.centers.getFacTerrain.url, { id }))
    .get<CenterFacTerrain | null>()
}
